<template>
  <div class="basket-wrapper">
    <DefDarkenBackground
      v-if="isOpenSmallBasket && items && items.length > 0"
      @close="changeOpenSmallBasket(false)"
    />
    <DefSlideRight v-if="items && items.length > 0">
      <Basket v-if="isOpenSmallBasket" class="small-basket-modal" />
    </DefSlideRight>
    <DefEmpty v-else-if="isOpenSmallBasket" @close="closeEmptyBasketMessage">
      {{ messages.noItems }}
    </DefEmpty>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import DefDarkenBackground from '@components/Def/DefDarkenBackground/DefDarkenBackground.vue';
import DefSlideRight from '@components/Def/DefAnimations/DefSlideRight.vue';
import DefEmpty from '@components/Def/DefEmpty/DefEmpty.vue';
import useAsyncComponent from '@use/useAsyncComponent';

export default {
  name: 'BasketWrapper',
  components: {
    DefEmpty,
    Basket: useAsyncComponent(() => import('@components/Basket/Basket.vue')),
    DefSlideRight,
    DefDarkenBackground,
  },
  props: ['result'],
  computed: {
    ...mapState({
      isOpenSmallBasket: ({ basket }) => basket.data.isOpenSmallBasket,
      items: ({ basket }) => basket.data.items,
      messages: ({ basket }) => basket.data.messages,
    }),
  },
  methods: {
    ...mapMutations({
      changeOpenSmallBasket: 'basket/changeOpenSmallBasket',
    }),
    closeEmptyBasketMessage({ target }) {
      if (!target.closest('.small-basket-control')) {
        this.changeOpenSmallBasket(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.basket-wrapper {
}
.small-basket-modal {
  position: fixed;
  z-index: 1001;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  @include point-md {
    width: 640px;
  }
  @include point-lg {
    width: 840px;
  }
}
</style>
